import range from 'lodash-es/range';

function getPageData(num, quantity, activeOffset) {
  const offset = (num - 1) * quantity;

  return {
    num,
    offset,
    active: offset === activeOffset,
  };
}

export function getPagerData(total, offset, quantity, width) {
  const pagesAmount = Math.ceil(total / (quantity || 1));
  const pageNum = offset / quantity + 1;

  const pagerData = {
    pagesAmount,
    pageNum,
    prevPage: pageNum > 1 ? getPageData(pageNum - 1, quantity, offset) : null,
    nextPage:
      pageNum < pagesAmount ? getPageData(pageNum + 1, quantity, offset) : null,
    visiblePages: [],
    headCollapsed: false,
    tailCollapsed: false,
    firstPage: getPageData(1, quantity, offset),
    lastPage: getPageData(pagesAmount, quantity, offset),
  };

  const indexToPageData = index => getPageData(index + 1, quantity, offset);

  if (pagesAmount > width) {
    const center = Math.ceil(width / 2);
    const minPos = center;
    const maxPos = pagesAmount - (width - center);
    const pos = Math.min(maxPos, Math.max(minPos, pageNum));
    const before = center - 3;
    const after = width - center - 2;
    const startIndex = pageNum > minPos ? pos - before - 1 : 0;
    const endIndex = pageNum < maxPos ? pos + after : pagesAmount;

    pagerData.headCollapsed = pos > minPos;
    pagerData.tailCollapsed = pos < maxPos;

    pagerData.visiblePages = range(startIndex, endIndex).map(indexToPageData);
  } else {
    pagerData.visiblePages = range(0, pagesAmount).map(indexToPageData);
  }

  return pagerData;
}
